
import { PropType, VNode } from 'vue';
import { VSelect } from 'vuetify/lib';

interface Options extends InstanceType<typeof VSelect> {
  // Inner component props
  multiple: boolean;

  //  data members
  internalValue: any;
  openOnClear: boolean;
  isMenuActive: boolean;

  //    Methods
  setValue(value?: any | any[]): void;
  setMenuIndex(index: number): void;

  $refs: {
    menu: any; //cannot get VMenu instance type into this
    content: HTMLElement;
    label: HTMLElement;
    input: HTMLInputElement;
    'prepend-inner': HTMLElement;
    'append-inner': HTMLElement;
    prefix: HTMLElement;
    suffix: HTMLElement;
  };
}

export default VSelect.extend<Options>({
  functional: false
}).extend({
  name: 'AlSelect',

  props: {
    clearCallback: {
      type: Function as PropType<(currentValue?: any) => any>
    }
  },

  methods: {
    clearableCallback() {
      this.setValue(
        this.clearCallback
          ? this.clearCallback(this.internalValue)
          : this.multiple
          ? []
          : null
      );
      this.setMenuIndex(-1);
      this.$nextTick(() => this.$refs.input && this.$refs.input.focus());

      if (this.openOnClear) this.isMenuActive = true;
    }
  }
});
